//export all modeals
export * from './answer.model';
export * from './building.model';
export * from './building.model';
export * from './buildingType.model';
export * from './chapter.model';
export * from './diagnostic.model';
export * from './indicateur.model';
export * from './indigroup.model';
export * from './questionnary.model';
export * from './society.model';
export * from './user.model';
export * from './incident.model';
export * from './statsheet.model';
export * from './objectif.model';
export * from './action.model';
export * from './task.model';
export * from './reference.model';
export * from './colors';
export * from './simpleAnswer.model';